















import Vue from "vue";
import { mapState } from 'vuex';
import { ImagePreviewState } from '../../store/state_models';

export default Vue.extend({
    computed: {
        ...mapState('imagePreview', {
            src: (s: ImagePreviewState) => {
                return s.src;
            },
        })
    },
    watch: {
        'src': function(src: string) {
            var _self = this;
            if (src) {
                $(_self.$refs.modal)
                    .modal('show')
                    .on('hidden.bs.modal', function () {
                        _self.$store.commit('imagePreview/show', '');
                    });;
            } else {
                $(_self.$refs.modal).modal('hide');
            }
        }
    },
    methods: {
        close() {
            var _self = this;
            $(_self.$refs.modal).modal('hide');
        }
    }
});
